.section {
  margin-bottom: 16px;
}

.heading {
  font-size: var(--tuna-typography-fontSize-2xl);
  margin-bottom: 4px;
}

.caption {
  display: block;
  margin-bottom: 8px;
  color: var(--tuna-palette-text-secondary);
}

.emptyActions {
  display: flex;
  gap: 8px;
}

.emptyHeading {
  margin: 0;
}

.emptyBody {
  margin-top: 4px;
  color: var(--tuna-palette-text-secondary);
}
